import React from "react";
import ReactDOM from "react-dom/client";
import XenStarAwards from "./XenStarAwards";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <XenStarAwards />
  </React.StrictMode>
);